import { Component, Input } from '@angular/core';
import { EventTemplateFont } from '@models/design-templates/event-template-font.model';
import { Event } from '@models/events/event.model';
import { UserAvatarComponent } from '@modules/shared/components/user-avatar/user-avatar.component';

@Component({
  selector: 'app-event-attendees',
  standalone: true,
  imports: [UserAvatarComponent],
  templateUrl: './event-attendees.component.html',
  styleUrl: './event-attendees.component.scss',
})
export class EventAttendeesComponent {
  @Input() event?: Event;
  @Input() avatarSize = 40;
  @Input() avatarPlaceholderFontSize = 16;
  @Input() maxNumber: number = 3;
  @Input() eventCardView = false;
  get font(): EventTemplateFont | undefined {
    return this.event?.eventTemplate?.font;
  }
  get limitedAttendees() {
    return this.event?.attendees?.slice(0, this.maxNumber) ?? [];
  }
}
